/** Penyerahan saya (senarai dan borang pemohon) dan muat turun bagi setiap versi (pelan F3). */
export default {
  mySubmissions: {
    title: 'Penyerahan saya',
    subtitle: 'Penyerahan pelan anda, semakannya dan keputusan ke atasnya.',
    empty: 'Anda belum mempunyai penyerahan. Mulakan dengan Penyerahan baharu.',
    back: 'Kembali ke penyerahan saya',
    formIntro: 'Penyerahan dibuat atas nama anda, menggunakan butiran akaun anda.',
    applicantHint:
      'Nama dan e-mel anda diambil daripada akaun anda. Tambahkan firma dan nombor pendaftaran profesional anda jika berkaitan.',
  },
  downloads: {
    title: 'Muat turun',
    revision: 'Fail versi {{revision}}',
    none: 'Belum ada fail untuk versi ini.',
    derivedHint: 'Fail GeoPackage dan Shapefile hanya wujud bagi versi yang lulus semakan.',
    cad_drawing: 'Lukisan asal',
    cleanup_original: 'Lukisan asal (sebelum pembersihan)',
    cleanup_changes: 'Senarai perubahan pembersihan',
    derived_gpkg: 'Fail GeoPackage (.gpkg)',
    derived_shp: 'Fail Shapefile (.zip)',
    download: 'Muat turun',
    downloadLabel: 'Muat turun {{name}}',
  },
} as const
